<div class="slots-diagram-header">
  <h3>
    <a *ngIf="showTimeSlotSwitches" class="slot-before" (click)="onPrevSlot()">
      <fa-icon [icon]="faCaretLeft"></fa-icon>
    </a>
    <span class="time">{{selectedSlot | translate}}</span>
    <a *ngIf="showTimeSlotSwitches" class="slot-after">
      <fa-icon [icon]="faCaretRight" (click)="onNextSlot()"></fa-icon>
    </a>
  </h3>
  <hr>
</div>
